import { Mail, MessageCircle, AlertCircle } from "lucide-react";

const AccessBlock = () => {
  return (
    <section className="py-12 md:py-16">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
            Confira seu acesso
          </h2>

          {/* Access info card */}
          <div className="bg-muted/50 rounded-lg p-6 md:p-8 border border-border mb-6">
            <div className="space-y-6">
              {/* Email info */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <Mail className="h-5 w-5 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold mb-1">E-mail</h3>
                  <p className="text-sm text-muted-foreground">
                    Enviamos o link de download e o arquivo para <strong className="text-foreground">{"{seu-email}"}</strong>
                  </p>
                </div>
              </div>

              {/* WhatsApp info */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <MessageCircle className="h-5 w-5 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold mb-1">WhatsApp</h3>
                  <p className="text-sm text-muted-foreground">
                    Enviamos a mensagem com o acesso para <strong className="text-foreground">{"{seu-telefone}"}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Spam warning */}
          <div className="flex items-start gap-3 p-4 bg-amber-500/10 border border-amber-500/20 rounded-lg">
            <AlertCircle className="h-5 w-5 text-amber-600 dark:text-amber-500 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-muted-foreground">
              Se não encontrar o e-mail, <strong className="text-foreground">verifique o Spam/Lixeira</strong> e marque como "Não é spam".
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessBlock;
